import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  setFormType,
  setFormStep,
  setFormUser,
  setFormDetail,
} from "../../redux/slice/form";

import ImgLogo from "../../images/logo.png";

export default function FrontLayoutMain(props) {
  const route_navigate = useNavigate();
  const dispatch = useDispatch();

  const backHome = () => {
    dispatch(setFormType(""));
    dispatch(setFormStep(""));
    dispatch(setFormUser(null));
    dispatch(setFormDetail({}));
    route_navigate("/");
  };

  return (
    <>
      <div className="flex justify-content-center w-full h-full front-bg-color">
        <div id="main-wrap" className="flex flex-column w-full overflow-y-auto">
          <div className="flex align-items-center bg-white border-bottom-1 border-main px-3 py-1">
            <img
              className="h-4rem cursor-pointer"
              src={ImgLogo}
              alt="logo"
              onClick={() => backHome()}
            />
            <div className="ml-3 text-2xl md:text-3xl font-bold">
              <span className="text-main">兒童近視治療共享</span>
              <span className="text-sub">決策輔助平台</span>
            </div>
          </div>

          <div className="flex-auto px-3 py-2">
            <Outlet />
          </div>

          <div className="text-center text-white bg-main px-2 py-1">
            兒童近視治療共享決策平台 - 國科會專題研究計畫
            MOST111-2314-B-255-004-MY3 版權所有 © 2023 All Rights Reserved.
          </div>
        </div>
      </div>
    </>
  );
}
